import classNames from "classnames/bind";
import React, { MouseEventHandler, forwardRef } from "react";
import { Skeleton } from "../Skeleton";
import styles from "./Link.module.scss";
import { LinkProps, ProgrammaticLinkProps } from "./types";

const cx = classNames.bind(styles);

// IMPROVE: this component is in need of a full refactor - still in place as legacy code using it needs to be migrated gradually
const Link = ({
  variant = "primary",
  label,
  underline = "hover",
  onClick,
  anchorTagProps = {},
  isLoading,
}: LinkProps) => {
  const onLinkClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.stopPropagation();

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Skeleton isLoading={isLoading}>
      <a
        onClick={onLinkClick}
        {...(!anchorTagProps?.href && typeof onClick === "function"
          ? { role: "button" }
          : {})}
        {...anchorTagProps}
        className={cx(
          "linkContainer",
          underline && `underline--${underline}`,
          variant && `linkContainer--${variant}`,
          anchorTagProps.className
        )}
      >
        {label}
      </a>
    </Skeleton>
  );
};

/**
 * A Link component variant that forwards ref and interrupts default navigation
 * so navigation can be done programmatically while still rendering the link
 * accessibly
 */
export const ProgrammaticLink = forwardRef<
  HTMLAnchorElement,
  ProgrammaticLinkProps
>(
  (
    { onClick, variant = "primary", underline = "hover", href, ...props },
    ref
  ) => {
    return (
      <a
        ref={ref}
        {...props}
        className={cx(
          "linkContainer",
          underline && `underline--${underline}`,
          variant && `linkContainer--${variant}`,
          props.className
        )}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();

          onClick(e);
        }}
        href={href}
      >
        {props.children}
      </a>
    );
  }
);

ProgrammaticLink.displayName = "ProgrammaticLink";

export default Link;
